module.exports = __webpack_public_path__ + "img/stethoscope.53aad487.svg";